import actions from './actions';

const {
  LIST_ELIGIBLE_MERCHANTS_BEGIN,
  LIST_ELIGIBLE_MERCHANTS_SUCCESS,
  LIST_ELIGIBLE_MERCHANTS_ERR,
  PAY_MERCHANT_BONUSES_BEGIN,
  PAY_MERCHANT_BONUSES_SUCCESS,
  PAY_MERCHANT_BONUSES_ERR,
} = actions;

const initState = {
  eligibleMerchants: [],
  loadingEligibleMerchants: false,
  errorEligibleMerchants: null,
  loadingPayBonuses: false,
  errorPayBonuses: null,
  payBonusesResult: null,
};

const merchantBonusesReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_ELIGIBLE_MERCHANTS_BEGIN:
      return { ...state, loadingEligibleMerchants: true, errorEligibleMerchants: null };
    case LIST_ELIGIBLE_MERCHANTS_SUCCESS:
      return { ...state, eligibleMerchants: [...data], loadingEligibleMerchants: false };
    case LIST_ELIGIBLE_MERCHANTS_ERR:
      return { ...state, errorEligibleMerchants: err, loadingEligibleMerchants: false };

    case PAY_MERCHANT_BONUSES_BEGIN:
      return { ...state, loadingPayBonuses: true, errorPayBonuses: null, payBonusesResult: null };
    case PAY_MERCHANT_BONUSES_SUCCESS:
      return { ...state, loadingPayBonuses: false, payBonusesResult: data };
    case PAY_MERCHANT_BONUSES_ERR:
      return { ...state, errorPayBonuses: err, loadingPayBonuses: false };

    default:
      return state;
  }
};

export { merchantBonusesReducer };
